const getComputedStyle =
document.body && (document.body as any).currentStyle ? function(elem: any) {
    return elem.currentStyle;
} : function(elem: any) {
    return (document.defaultView as any).getComputedStyle(elem, null);
};

function autoOrScroll(text: any) {
    return text == 'scroll' || text == 'auto';
}

function getActualCss(elem: any, style: any) {
    return getComputedStyle(elem)[style];
}

function isXScrollable(elem: any) {
    return elem.offsetWidth < elem.scrollWidth &&
        autoOrScroll(getActualCss(elem, 'overflow-x'));
}

function isYScrollable(elem: any) {
    return elem.offsetHeight < elem.scrollHeight &&
        autoOrScroll(getActualCss(elem, 'overflow-y'));
}



function hasScroller(elem: any) {
    return isYScrollable(elem) || isXScrollable(elem);
}

const elementsWithScrolls = () => {
    return [].filter.call(document.querySelectorAll('*'), hasScroller);
}

export {elementsWithScrolls};